import {CcFormDialogComponent} from "../crystal-elements/form-dialog/cc-form-dialog.component";

export class BatchUtils {

  static labelCheckboxChanged( fieldsToUpdate: string[],
                               ccFormDialog: CcFormDialogComponent,
                               field: string,
                               checked: boolean) {
    const fieldAddedIndex = fieldsToUpdate.findIndex(value => value == field);
    if (fieldAddedIndex >= 0 && !checked) {
      fieldsToUpdate.splice(fieldAddedIndex, 1);
    } else if (fieldAddedIndex < 0 && checked) {
      fieldsToUpdate.push(field);
    }
    ccFormDialog?.reloadFieldValueMap();
    ccFormDialog?.markForCheck();
    ccFormDialog?.validateForm();
  }
}

